import React, { useState, useContext } from "react";
import SearchField from "../SearchField/SearchField";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import SocketContext from "../../contexts/SocketContext";

import "./AddUserModal.css";

const AddUserModal = ({ show, setShow, reloaddata, setReloaddata }) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // New User
  const [newuser, setNewuser] = useState();

  // Search field clean up
  const [toggleSFclear, setToggleSFclear] = useState(false);

  //clean up
  const cleanNewUser = () => {
    setNewuser({});
    setToggleSFclear(!toggleSFclear);
  };

  // handle input change
  const handleInputChange = (e) => {
    setNewuser({ ...newuser, [e.target.name]: e.target.value });
  };
  // handle role select
  const handleRoleSelect = (item) => {
    setNewuser({ ...newuser, ["roleID"]: item.roleID, ["role"]: item.role });
  };

  // save new user
  const saveNewUser = async () => {
    try {
      const response = await axiosPrivate.post("/api/users/addnewuser", {
        newuser,
      });
      if (response.data.msg === "Saved") {
        let newuserfromsocket = { ...newuser, ["userIO"]: response.data.userID };
        setShow(false);
        cleanNewUser();
        setReloaddata(!reloaddata);
        await socket.emit("newuser", newuserfromsocket);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  return (
    <div className={show ? "custommodal" : "custommodal hide"}>
      <div className='umodal-main'>
        <div className='au-header'>
          <h2>Add New Customer:</h2>
          <p
            onClick={(e) => {
              setShow(false);
              cleanNewUser();
            }}
          >
            Close
          </p>
        </div>
        <form
          className='addnewuser'
          onSubmit={(e) => {
            e.preventDefault();
            saveNewUser();
          }}
        >
          <div className='form-item'>
            <label>User Code:</label>
            <input
              required
              name='userCode'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newuser?.userCode || ""}
              placeholder='3 CAPS letter user code'
            />
          </div>
          <div className='form-item'>
            <label>Name:</label>
            <input
              required
              name='name'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newuser?.name || ""}
            />
          </div>
          <div className='form-item'>
            <label>Lastname:</label>
            <input
              required
              name='lastname'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newuser?.lastname || ""}
            />
          </div>
          <div className='form-item'>
            <label>User:</label>
            <input
              required
              name='user'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newuser?.user || ""}
              placeholder='email'
            />
          </div>
          <div className='form-item'>
            <label>Role:</label>
            <SearchField
              required={true}
              searchURL='/api/roles/getroles'
              value={newuser?.role}
              valueName='role'
              valueID='roleID'
              style={{ width: "95%" }}
              onItemSelect={handleRoleSelect}
              clearfield={toggleSFclear}
            />
          </div>
          <div className='form-item'>
            <label>Active:</label>
            <select
              required
              onChange={(e) => {
                setNewuser({ ...newuser, ["active"]: e.target.value });
              }}
            >
              <option value='' disabled selected={!newuser?.active}>
                Select your option
              </option>

              <option selected={newuser?.active === "y"} value='y'>
                Yes
              </option>
              <option selected={newuser?.active === "n"} value='n'>
                No
              </option>
            </select>
          </div>
          <div className='form-item'>
            <label>First Login:</label>
            <select
              required
              onChange={(e) => {
                setNewuser({ ...newuser, ["firstLogin"]: e.target.value });
              }}
            >
              <option value='' disabled selected={!newuser?.firstLogin}>
                Select your option
              </option>

              <option selected={newuser?.firstLogin === "y"} value='y'>
                Yes
              </option>
              <option selected={newuser?.firstLogin === "n"} value='n'>
                No
              </option>
            </select>
          </div>
          <div className='form-buttons'>
            <button type='button' onClick={(e) => cleanNewUser()}>
              Clear
            </button>
            <button type='submit' className='mainbutton'>
              Save New
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
